import React from 'react'

function Navbar() {
    return (
        <div className='navbar'>
            <p>Top Courses</p>
        </div>
    )
}

export default Navbar